import type { AssetManager } from "../../assets/asset-manager";
import type { CharacterDefinition } from "../../data/characters";
import type { Scene } from "../scene";
import type { PartyState } from "./formation-state";
import { FormationView } from "./formation-view";

export interface FormationSceneCallbacks {
  getPartyState: () => PartyState;
  updatePartyState: (party: PartyState) => void;
  home: () => void;
}

export class FormationScene implements Scene {
  private view: FormationView | null = null;

  constructor(
    private readonly assets: AssetManager,
    private readonly characters: CharacterDefinition[],
    private readonly callbacks: FormationSceneCallbacks,
  ) {}

  async mount(root: HTMLElement): Promise<void> {
    this.view = new FormationView(root, this.assets, this.characters, {
      getPartyState: this.callbacks.getPartyState,
      updatePartyState: this.callbacks.updatePartyState,
      onBack: this.callbacks.home,
    });
  }

  unmount(): void {
    this.view?.destroy();
    this.view = null;
  }
}
